/**
 * Returns the temporary auth-worker token captured by the synchronous bootstrap
 * in index.html and removes the last in-memory reference to it.
 */
export function consumeAuthCallbackJwt(): string | null {
	const jwt = window.secodaAuthCallbackJwt ?? null;
	delete window.secodaAuthCallbackJwt;
	return jwt;
}
